export default __webpack_public_path__ + "static/media/cjenik-megaton.8084e8bb.jpg";